import { logRequest } from './requestLog';
import { getApiUrl } from './urlHelper';

interface FetchApiOptions extends RequestInit {
    body?: any; // Automatically stringified if object
    skipLog?: boolean;
}

/**
 * Enhanced fetch wrapper for Corpora API.
 * - Auto-constructs URL using getApiUrl
 * - Attaches X-Corpora-Tester-Pin if present
 * - Handles JSON body stringification
 * - Logs requests to diagnostics
 */
export async function fetchApi(path: string, options: FetchApiOptions = {}): Promise<Response> {
    const url = getApiUrl(path);
    const headers = new Headers(options.headers || {});

    // Attach Tester PIN if available
    const pin = typeof localStorage !== 'undefined'
        ? (localStorage.getItem('fc_tester_pin') || sessionStorage.getItem('fc_tester_pin'))
        : null;

    if (pin) {
        headers.set('X-Corpora-Tester-Pin', pin);
        // Also set legacy header just in case, though Worker prefers new one
        headers.set('X-FC-Tester-Pin', pin);
    }

    // Handle JSON body
    let body = options.body;
    if (body && typeof body === 'object' && !(body instanceof Blob) && !(body instanceof FormData) && !(body instanceof URLSearchParams)) {
        body = JSON.stringify(body);
        if (!headers.has('Content-Type')) {
            headers.set('Content-Type', 'application/json');
        }
    }

    let status = 0;
    let error: string | undefined;

    try {
        const res = await fetch(url, {
            ...options,
            headers,
            body
        });
        status = res.status;

        if (!res.ok) {
            // We don't read body here to avoid consuming it, 
            // but we flag it as an error for logging.
            error = res.statusText;
        }

        return res;
    } catch (e: any) {
        error = e.message;
        throw e;
    } finally {
        if (!options.skipLog) {
            logRequest(options.method || 'GET', path, status, error);
        }
    }
}

export { logRequest, getLogs } from './requestLog';
